'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _emojione = require('emojione');

var _emojione2 = _interopRequireDefault(_emojione);

var _filter = require('lodash/filter');

var _filter2 = _interopRequireDefault(_filter);

var _includes = require('lodash/includes');

var _includes2 = _interopRequireDefault(_includes);

var _reactEventListener = require('react-event-listener');

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _store = require('store');

var _store2 = _interopRequireDefault(_store);

var _emoji = require('./emoji');

var _emoji2 = _interopRequireDefault(_emoji);

var _emojiCategory = require('./emoji-category');

var _emojiCategory2 = _interopRequireDefault(_emojiCategory);

var _emojiModifiers = require('./emoji-modifiers');

var _emojiModifiers2 = _interopRequireDefault(_emojiModifiers);

var _emojiCategories = require('./emoji-categories');

var _emojiCategories2 = _interopRequireDefault(_emojiCategories);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

var _storeEmoji = require('../internal/store-emoji');

var _storeEmoji2 = _interopRequireDefault(_storeEmoji);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_emojione2.default.emojiSize = '64';

var propTypes = {
  /**
   * Callback fired when an emoji is clicked
   *
   * function(event: object, emoji: object) => void
   */
  sendEmoji: _propTypes2.default.func.isRequired,
  /** Override the styles of the root element */
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the header element */
  headerStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the color modifiers */
  modifierStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the emoji category */
  categoryStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the emojis */
  emojiStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the footer element */
  footerStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the footer icons */
  iconStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Toggle the EmojiMenu's visibility */
  open: _propTypes2.default.bool,
  /** Function to hide the menu */
  hideMenu: _propTypes2.default.func.isRequired,
  /** Category icon color */
  iconColor: _propTypes2.default.string,
  color: _propTypes2.default.string.isRequired
};

var defaultProps = {
  style: {},
  headerStyle: {},
  modifierStyle: {},
  categoryStyle: {},
  emojiStyle: {},
  footerStyle: {},
  iconStyle: {},
  open: false,
  iconColor: _colors2.default.icons
};

var displayName = 'EmojiMenu';

/** Menu for sending messages with emoji */

var EmojiMenu = function (_Component) {
  _inherits(EmojiMenu, _Component);

  function EmojiMenu(props) {
    _classCallCheck(this, EmojiMenu);

    var _this = _possibleConstructorReturn(this, (EmojiMenu.__proto__ || Object.getPrototypeOf(EmojiMenu)).call(this, props));

    _this.handleClickOutside = function (event) {
      var hideMenu = _this.props.hideMenu;


      hideMenu(event);
    };

    _this.handleKeyUp = function (event) {
      var hideMenu = _this.props.hideMenu;


      if (event.which === 27) {
        hideMenu(event);
      }
    };

    var storedEmojis = _store2.default.get('recent-emoji');

    _this.state = {
      tone: 'tone0',
      storedEmojis: storedEmojis || [],
      category: 'people'
    };

    _this.changeTone = _this.changeTone.bind(_this);
    _this.changeCategory = _this.changeCategory.bind(_this);
    _this.sendEmoji = _this.sendEmoji.bind(_this);
    return _this;
  }

  _createClass(EmojiMenu, [{
    key: 'changeTone',
    value: function changeTone(tone) {
      this.setState({
        tone: tone
      });
    }
  }, {
    key: 'changeCategory',
    value: function changeCategory(category) {
      this.setState({
        category: category
      });
    }
  }, {
    key: 'sendEmoji',
    value: function sendEmoji(event, emoji) {
      var sendEmoji = this.props.sendEmoji;


      (0, _storeEmoji2.default)(emoji);
      sendEmoji(event, emoji);

      var storedEmojis = _store2.default.get('recent-emoji');

      this.setState({
        storedEmojis: storedEmojis || []
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          tone = _state.tone,
          storedEmojis = _state.storedEmojis,
          category = _state.category;

      var _props = this.props,
          style = _props.style,
          headerStyle = _props.headerStyle,
          modifierStyle = _props.modifierStyle,
          categoryStyle = _props.categoryStyle,
          emojiStyle = _props.emojiStyle,
          footerStyle = _props.footerStyle,
          iconStyle = _props.iconStyle,
          sendEmoji = _props.sendEmoji,
          color = _props.color,
          open = _props.open,
          eventTypes = _props.eventTypes,
          outsideClickIgnoreClass = _props.outsideClickIgnoreClass,
          preventDefault = _props.preventDefault,
          stopPropagation = _props.stopPropagation,
          disableOnClickOutside = _props.disableOnClickOutside,
          enableOnClickOutside = _props.enableOnClickOutside,
          hideMenu = _props.hideMenu,
          iconColor = _props.iconColor,
          custom = _objectWithoutProperties(_props, ['style', 'headerStyle', 'modifierStyle', 'categoryStyle', 'emojiStyle', 'footerStyle', 'iconStyle', 'sendEmoji', 'color', 'open', 'eventTypes', 'outsideClickIgnoreClass', 'preventDefault', 'stopPropagation', 'disableOnClickOutside', 'enableOnClickOutside', 'hideMenu', 'iconColor']);

      if (!open) {
        return null;
      }

      var modifiers = (0, _filter2.default)(_emoji2.default, { category: 'modifier' });

      var filteredEmoji = (0, _filter2.default)(_emoji2.default, function (emoji) {
        if (emoji.category !== category) {
          return false;
        }

        if (emoji.diversity) {
          return (0, _includes2.default)(emoji.title, tone);
        }

        return true;
      });

      return _react2.default.createElement(
        'section',
        _extends({ style: _getStyles2.default.root(style) }, custom),
        _react2.default.createElement(_emojiModifiers2.default, {
          modifiers: modifiers,
          changeTone: this.changeTone,
          tone: tone,
          style: headerStyle,
          modifierStyle: modifierStyle
        }),
        storedEmojis.length > 0 && category === 'recent' ? _react2.default.createElement(_emojiCategory2.default, {
          emojis: storedEmojis,
          category: 'recent',
          sendEmoji: this.sendEmoji,
          style: categoryStyle,
          emojiStyle: emojiStyle
        }) : null,
        category !== 'recent' ? _react2.default.createElement(_emojiCategory2.default, {
          emojis: filteredEmoji,
          category: category,
          sendEmoji: this.sendEmoji,
          style: categoryStyle,
          emojiStyle: emojiStyle
        }) : null,
        _react2.default.createElement(_emojiCategories2.default, {
          changeCategory: this.changeCategory,
          category: category,
          activeColor: color,
          recent: storedEmojis.length > 0,
          style: footerStyle,
          iconStyle: iconStyle,
          iconColor: iconColor
        }),
        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyUp: this.handleKeyUp })
      );
    }
  }]);

  return EmojiMenu;
}(_react.Component);

EmojiMenu.propTypes = propTypes;
EmojiMenu.defaultProps = defaultProps;
EmojiMenu.displayName = displayName;

exports.default = EmojiMenu;
module.exports = exports.default;